<template>
  <div class="bet-slip-options" :class="{ 'open-options': open }">
    <div class="flex head" @click="open = !open">
      <div class="caption">{{ $t('bet-slip.multiple-bet-options') }}</div>
      <!--div class="icon-square">
        <arrow-icon class="icon" :title="null" />
      </div-->
    </div>
    <div class="body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ArrowIcon from 'vue-material-design-icons/ChevronDown.vue'

export default {
  components: { ArrowIcon },
  data () {
    return {
      open: true
    }
  }
}
</script>

<style scoped>
.bet-slip-options { margin-top: 10px; background: #d4dbe3; border-radius: 5px; }
.head { background: #8c9eff; border-radius: 5px; cursor: pointer; height: 30px; line-height: 30px; padding-left: 10px; position: relative; }
.open-options .head { border-radius: 5px 5px 0 0; }
.caption { flex: 1 1; }
.icon-square { display: flex; justify-content: center; height: 30px; margin-right: 4px; width: 30px; }
.icon { color: #fff; font-size: 24px; margin-top: -4px; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; -o-transition: all 0.3s; transition: all 0.3s; }
.open-options .icon { margin-top: 6px; -webkit-transform: rotate(-180deg); -moz-transform: rotate(-180deg); -o-transform: rotate(-180deg); transform: rotate(-180deg); }
.body { background: rgba(255, 255, 255, .05); border-radius: 0 0 5px 5px; display: none; }
.open-options .body { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipOptions.vue